<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent"> 
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Settings" @click="$router.push('/settings')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <!-- user guide for workdays need to be updated to employee level details -->
                    <!-- <help-link appId="settings" pageId="workday" color="white"></help-link> -->
                </v-toolbar>
            </v-card>
            
            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="mt-8">
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert> 

            <v-alert :value="true" color="warning" icon="warning" outline dismissible class="mt-8">
               Working Days and Working Hours are critical factors in Payroll computation. Any modification will immediately affect all subsequent payroll processing. Please proceed with caution.
            </v-alert>

            <v-card class="elavation-1 mt-5">
                <v-toolbar flat height="35px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search employee name" single-line hide-details></v-text-field>
                    </div>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? [] : headers"
                    :items="workdays_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="headers.length" class="pa-1">
                                <v-card class="elevation-1">
                                    <v-toolbar flat height="42">
                                        <v-chip class="employee-item">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.user.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.user.firstName}} {{props.item.user.lastName}}
                                        </v-chip>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Sun</div>
                                                    <v-switch v-model="props.item.sunday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Sunday', props.item.sunday)" class="switch-item"></v-switch>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Mon</div>
                                                    <v-switch v-model="props.item.monday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Monday', props.item.monday)" class="switch-item"></v-switch>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Tue</div>
                                                    <v-switch v-model="props.item.tuesday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Tuesday', props.item.tuesday)" class="switch-item"></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                               <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Wed</div>
                                                    <v-switch v-model="props.item.wednesday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Wednesday', props.item.wednesday)" class="switch-item"></v-switch>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Thu</div>
                                                    <v-switch v-model="props.item.thursday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Thursday', props.item.thursday)" class="switch-item"></v-switch>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Fri</div>
                                                    <v-switch v-model="props.item.friday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Friday', props.item.friday)" class="switch-item"></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                               <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Sat</div>
                                                    <v-switch v-model="props.item.saturday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Saturday', props.item.saturday)" class="switch-item"></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6>
                                                    <div class="caption grey--text text--darken-1">Attendance Required</div>
                                                    <v-switch v-model="props.item.clockInOutRequired" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getAttendanceRequiredTooltip(props.item)" class="switch-item"></v-switch>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <div class="caption grey--text text--darken-1">Attendance Pic Required</div>
                                                    <v-switch v-model="props.item.clockInOutPicRequired" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getclockInOutPicRequiredTooltip(props.item)" class="switch-item"></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                               <v-flex xs6>
                                                    <div class="caption grey--text text--darken-1">Work Hours / Day</div>
                                                    <v-select
                                                        solo
                                                        :items="[7,8,9]"
                                                        v-model="props.item.workHoursPerDay"     
                                                        @change="update(props.item)"   
                                                        class="select-item"     
                                                        
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>
                        
                        <!-- desktop view -->
                        <tr v-else>
                            <td>
                                <v-chip class="employee-item">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.user.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.user.firstName}} {{props.item.user.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <v-switch v-model="props.item.sunday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Sunday', props.item.sunday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.monday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Monday', props.item.monday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.tuesday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Tuesday', props.item.tuesday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.wednesday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Wednesday', props.item.wednesday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.thursday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Thursday', props.item.thursday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.friday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Friday', props.item.friday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.saturday" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getDayTooltip('Saturday', props.item.saturday)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.clockInOutRequired" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getAttendanceRequiredTooltip(props.item)" class="switch-item"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="props.item.clockInOutPicRequired" :readonly="!hasEditRights" color="primary" @change="update(props.item)" :title="getclockInOutPicRequiredTooltip(props.item)" class="switch-item"></v-switch>
                            </td>
                            <td title="Click to set working hours per day">
                                <v-select
                                    solo
                                    :items="[7,8,9]"
                                    v-model="props.item.workHoursPerDay"     
                                    @change="update(props.item)"   
                                    class="select-item"     
                                    
                                ></v-select>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
            
            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout>
</template>
<script>

import workdaysApi from '@/api/workdays'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasEditRights } from '@/helpers/access-permissions'

export default { 
    name: 'Company Workdays',
    metaInfo: {
        title: 'Company Workdays',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Workdays' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },    
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            headers: [
                {text: 'Employee',align: 'left',value: 'lastName',width: '20%', sortable:true},
                {text: 'Sun',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Mon',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Tue',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Wed',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Thu',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Fri',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Sat',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Att. Req.',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Att. Pic Req.',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Hrs/Day',align: 'left',value: '',width: '5%', sortable:false},
            ],
            error: false,
            errorMessage: '',
            loading: false,
            workdays: [],
        }
    },
    methods: { 
        getDayTooltip(day, isWorking) {
            return isWorking
            ? `Click to mark ${day} as a non-working day`
            : `Click to mark ${day} as a working day`;
        },
        getAttendanceRequiredTooltip(data) {
            return data.clockInOutRequired ?
                'Click to make clock-in/out NOT required' :
                'Click to make clock-in/out required'
        },
        getclockInOutPicRequiredTooltip(data) {
            return data.clockInOutPicRequired ?
                'Click to make clock-in/out picture NOT required' :
                'Click to make clock-in/out picture required'
        },
        async update(data) {
            try {
                await workdaysApi.update(data)
            } catch (error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async getWorkDays(show_loading) {
            try {
                this.loading = show_loading
                const response = await workdaysApi.get() 
                if (response && response.status == 200) {
                    this.workdays = response.data.items
                }
                this.loading = false
            } catch (error) {
                this.errorMessage = error
                this.error = true
            }
        },
        updateHandler(data) {
            if (data!=this.$store.state.userId) {
                this.getWorkDays(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Workdays Settings'
        })

        this.getWorkDays(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        companyIdStr() {
            return this.$store.state.companyId
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        workdays_filtered() {
            let temp = this.workdays

            // search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase();

                temp = temp.filter(item => {
                    const firstName = item.user.firstName.toLowerCase().includes(searchLower)
                    const lastName = item.user.lastName.toLowerCase().includes(searchLower)
                    return firstName || lastName
                })
            }

            // Used for sorting
            // altertive option, do not create a User class, just add lastName, firstName in the main class
            temp = temp.map(e => ({
                ...e,
                lastName: e.user.lastName
            }))

            return temp;
        },
        pageQueryId() {
            return `${this.companyIdStr}_company_workdays`
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.workdays,
                    notificationTypeId: notificationTypes.workdays
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script> 
<style scoped>
.employee-item {
    margin-left:-5px;
}
.switch-item {
    margin-bottom:-15px;
}
.select-item {
    margin-bottom:-25px;
    width:60px;
}
.section-layout {
    padding:0px 20px 0px 50px;
}
</style>